import styled from "@yb/styled-px2rem";
import {Title, Ellipsis} from "@FRAMEWORK/ui/mobile/text";
import {Flex, Stack} from "@FRAMEWORK/ui/mobile/layout";
import imgButton from "@PUBLIC/M/images/btn/btn_spr.png";
import SpriteImage from "@PUBLIC/M/images/ico/ico_spr.png";

const Wrap = styled.div`
	position: relative;
`;

const FixedHeader = styled.div`
	position: sticky;
	top: 60px;
	transition: top 0.5s ease-out 0s;
	z-index: 15;
`;

const ProductList = styled.ul`
	padding: 0 15px;
`;

const ProductListItem = styled.li`
	position: relative;
	padding: 30px 15px;
	margin: 0 -15px;
	&:not(:last-child) {
		border-bottom: 1px solid var(--line-color);
	}
`;

const ProductListItemData = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	cursor: pointer;
`;

const ProductTitle = styled(Title)`
	padding-top: 10px;
	margin-bottom: 10px;
	font-size: 17px;
`;

const Summary = styled.div`
	display: flex;
	margin-top: 12px;
	line-height: 1;
	flex-direction: column;
	gap: 8px;

	dl {
		display: flex;
	}

	dt {
		margin-right: 10px;
		color: var(--emp-color);
		flex-shrink: 0;
	}
`;

const SummaryDeparture = styled.dd`
	i {
		display: block;
		line-height: 1.5;
		margin-top: -4px;
	}
`;

const Transportation = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	row-gap: 5px;

	div + div {
		margin: 0 5px 0 10px;
	}
`;

const MapIcon = styled.i`
	position: relative;
	left: 0;
	width: 15px;
	height: 15px;

	&:before {
		position: absolute;
		top: 0;
		display: block;
		width: 4px;
		height: 4px;
		border-radius: 50%;
		border: 4px solid var(--default-color);
		background-color: #fff;
		content: "";
	}

	&:after {
		position: absolute;
		top: 10px;
		left: 2px;
		display: block;
		width: 0;
		height: 10px;
		border-left: 4px solid transparent;
		border-right: 4px solid transparent;
		border-top: 5px solid var(--default-color);
		transform-origin: 0 100%;
		content: "";
	}
`;

const Price = styled.em`
	font-size: 15px;
	color: var(--red-color);
	line-height: 1;

	strong {
		font-size: 17px;
	}
`;

const CircleButtonWrap = styled.div`
	position: absolute;
	top: 40px;
	right: 15px;
	display: flex;
	gap: 5px;
`;

const CircleButton = styled.div`
	display: inline-flex;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background-color: #fff;
	align-items: center;
	justify-content: center;
	z-index: 5;
`;

const CompareButton = styled.div`
	position: fixed;
	bottom: 0;
	z-index: 5;
	display: flex;
	width: 100%;

	button {
		height: 50px;
		flex-basis: 50%;
	}
`;

const StackWrap = styled.div`
	position: absolute;
	top: 0;
	display: flex;
	width: 100%;
	height: 30px;
	padding: 0 15px;
	background-color: rgba(0, 0, 0, 0.4);
	align-items: center;
	justify-content: space-between;
	flex-flow: row nowrap;
	white-space: nowrap;

	> div {
		font-size: 12px;
		font-weight: normal;
		color: var(--bl-color);
		margin-left: 30px;
	}
	em {
		margin-right: 3px;
		color: #fff;
	}

	i {
		width: 12px;
		height: 12px;
		margin-right: 4px;
	}

	p {
		${Ellipsis(1)};
		display: block;
		font-size: 12px;
		color: #fff;
		flex-grow: 2;
	}
`;

const StarImg = styled.i`
	display: inline-block;
	width: 14px;
	height: 14px;
	background: url(${SpriteImage}) 0px -160px / 300px 300px no-repeat;
`;

const Region = styled.h3`
	font-size: 18px;
	font-weight: bold;
	color: var(--emp-color);
	line-height: 1;
`;

const DetailWrap = styled(Stack)`
	li {
		font-size: 13px;
		letter-spacing: -0.65px;
		color: var(--emp-color);
	}
`;

const DetailFilter = styled.div`
	height: auto;
	border-bottom: 1px solid var(--line-color);
	background-color: #fff;
`;

const DetailFilterTop = styled(Flex)`
	padding: 10px 15px;
`;

const Tag = styled.span`
	display: flex;
	height: 20px;
	padding: 0 10px;
	background-color: #fff;
	font-size: 12px;
	justify-content: center;
	align-items: center;
	border: 1px solid var(--red-color);
	color: var(--red-color);
`;

const TagGroup = styled.div`
	position: absolute;
	bottom: -10px;
	left: 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
`;

const ProductCheck = styled.input`
	position: absolute;
	top: 40px;
	left: 15px;
	display: block;
	width: 25px;
	height: 21px;
	margin: 0;
	border: none;
	background: transparent url(${imgButton}) 0 -34px / 100px 100px;
	vertical-align: middle;
	z-index: 5;
	box-sizing: border-box;

	&:focus {
		border: none;
		background: transparent url(${imgButton}) 0 -34px / 100px 100px;
	}
`;

const EventBanner = styled.div`
	padding: 15px 15px 0;
	font-size: 0;
	vertical-align: top;
`;

const PriceWrap = styled.div`
	display: flex;
	justify-content: end;
	margin-top: 10px;
`;

const PromotionFlag = styled.em`
	display: inline-flex;
	align-items: center;
	height: 20px;
	padding: 0 6px;
	border-radius: 4px;
	border: 1px solid #3964f0;
	background-color: #ebeffa;
	font-size: 12px;
	font-family: "PT-regular";
	box-sizing: border-box;
	color: #3964f0;
`;

const PriceBox = styled.div`
	display: flex;
	width: auto;
	flex-direction: column;
	align-items: end;
`;

const PriceTag = styled.div`
	display: flex;
	gap: 4px;
	margin-right: 10px;
`;

const TagYellowpangdeal = styled.span`
	position: relative;
	display: flex;
	padding-right: 7px;
	margin-right: 5px;

	span {
		display: inline-block;
		padding: 4px 4px 4px 6px;
		background-color: #ffde2f;
		font-size: 12px;
		color: #ff1e00;
		line-height: 1;
		letter-spacing: -0.1rem;

		&:after {
			position: absolute;
			top: 0;
			right: 0;
			width: 0;
			height: 0;
			border-bottom: 10px solid transparent;
			border-top: 10px solid transparent;
			border-left: 8px solid #ffde2f;
			border-right: 0px solid transparent;
			content: "";
		}
	}
`;

const YellowLiveFlag = styled.span`
	position: relative;
	display: flex;
	align-items: center;
	height: 20px;
	padding: 0 7px;
	margin-right: 5px;
	border-radius: 10px;
	background-color: #ff5858;

	span {
		line-height: 1;
		color: #fff;
		font-size: 10px;
	}
`;

const BeforePrice = styled.i`
	margin-right: 5px;
	font-size: 12px;
	font-style: normal;
	text-decoration: line-through;
	color: #222;

	strong {
		font-size: 14px;
	}
`;

const CouponBox = styled.div`
	display: flex;
	margin-top: 11px;
	align-items: center;
	gap: 9px;

	em {
		color: var(--emp-color);
		line-height: 1;
	}
`;

const CouponIcon = styled.span`
	display: flex;
	height: 16px;

	i {
		display: flex;
		height: 100%;
		min-width: 30px;
		padding: 0 4px;
		margin-bottom: 1px;
		border-top: 1px solid #d6d6d6;
		border-bottom: 1px solid #d6d6d6;
		font-size: 10px;
		font-style: normal;
		color: var(--emp-color);
		align-items: center;
		justify-content: center;
	}

	&:before {
		display: block;
		width: 3px;
		height: 18px;
		background: url(${SpriteImage}) -75px -79px / 300px 300px;
		content: "";
	}

	&:after {
		display: block;
		width: 7px;
		height: 18px;
		background: url(${SpriteImage}) -80px -79px / 300px 300px;
		content: "";
	}
`;

const InfoGroup = styled(Flex)`
	position: relative;
	padding: 20px 35px 15px 15px;
	box-sizing: border-box;
	border-radius: 5px;
	background: var(--disabled-color);

	em {
		display: block;
		margin-bottom: 5px;
		color: var(--blue-color);
	}
`;
const InfoGroupContent = styled.div<{show?: boolean}>`
	overflow: hidden;
	max-height: 72px;
	line-height: 1.43;

	${props =>
		props.show &&
		`
        max-height: none;
    `}
`;

const BenefitButtonWrap = styled.div`
	position: absolute;
	bottom: 5px;
	right: 5px;
	padding: 10px;
	z-index: 5;
`;

const BenefitButton = styled.button`
	width: 25px;
	height: 25px;
	border: 1px solid var(--bl-color);
	background: #fff;
	cursor: pointer;
	z-index: 5;

	&:before,
	&:after {
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		background-color: var(--gray-color);
		transform: translate(-50%, -50%);
		content: "";
	}
	:after {
		width: 12px;
		height: ${`1px`};
	}

	:before {
		width: ${`1px`};
		height: 12px;
	}
`;

const FilterItem = styled.span`
	display: inline-block;
	margin-right: 8px;

	input[type="checkbox"] {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		-webkit-clip: rect(0, 0, 0, 0);
		clip: rect(0, 0, 0, 0);
		border: 0;

		&:checked + label {
			background-color: var(--yellow-color);
		}
	}

	label {
		display: inline-flex;
		height: 28px;
		padding: 0 15px;
		border: 1px solid var(--line-color);
		border-radius: 20px;
		background: #fff;
		font-size: 15px;
		color: var(--emp-color);
		line-height: 1;
		align-items: center;
	}

	&:last-child {
		color: red;
	}
`;

const AreaGridList = styled.ul`
	display: grid;
	padding: 15px;
	border-bottom: 1px solid var(--line-color);
	grid-template-columns: repeat(2, 1fr);
	gap: 10px 15px;

	li {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	input {
		flex-shrink: 0;
	}

	label {
		display: flex;
		align-items: center;
		justify-content: center;

		${Ellipsis(1)}
	}
`;

const ResetButton = styled.button`
	position: relative;
	padding-left: 25px;
	padding-right: 16px;
	margin-right: 15px;
	font-size: var(--default-size);
	color: var(--default-color);
	flex-shrink: 0;

	&:before {
		position: absolute;
		left: 0;
		top: 50%;
		display: block;
		width: 15px;
		height: 15px;
		background: url(${SpriteImage}) -135px 0px / 300px 300px no-repeat;
		transform: translateY(-50%);
		content: "";
	}

	&:after {
		position: absolute;
		right: 0;
		top: 50%;
		width: 1px;
		height: 13px;
		background-color: var(--line-color);
		transform: translateY(-50%);
		content: "";
	}
`;

const FilterTagHeader = styled.div<{isScroll: boolean}>`
	position: sticky;
	top: ${props => (props.isScroll ? `110px` : `-110px`)};
	z-index: 10;
	transition: top 0.5s ease-out;
`;

const ImageItem = styled.div`
	width: 100%;
	height: 200px;

	img:not(.fallback_thumb) {
		width: 100%;
		height: 100%;
	}
`;

export {
	Wrap,
	FixedHeader,
	ProductList,
	ProductListItem,
	ProductListItemData,
	ProductTitle,
	Summary,
	SummaryDeparture,
	Transportation,
	MapIcon,
	Price,
	CircleButtonWrap,
	CircleButton,
	CompareButton,
	StackWrap,
	Region,
	DetailWrap,
	DetailFilter,
	Tag,
	TagGroup,
	ProductCheck,
	EventBanner,
	DetailFilterTop,
	StarImg,
	PriceWrap,
	PromotionFlag,
	PriceBox,
	TagYellowpangdeal,
	YellowLiveFlag,
	BeforePrice,
	CouponBox,
	CouponIcon,
	InfoGroup,
	InfoGroupContent,
	BenefitButtonWrap,
	BenefitButton,
	FilterItem,
	AreaGridList,
	ResetButton,
	FilterTagHeader,
	ImageItem,
	PriceTag,
};
